'use strict';

import GenericTabContainer from '../GenericTabContainer/GenericTabContainer';
import $ from 'jQuery';
import config from '../../js/config';
import mediator from '../../js/mediator';

// This is a base class and should only ever be extended to set API end point.
export class ManufacturerTabsView extends GenericTabContainer {
  constructor(options) {
    super(options);
    this.initialize();
    this.initializeMarketingTracking();
  }
  setSelectedTab($el) {
    $el.parent().addClass(config.classes.isSelected);
    $('.SideNav-menu-link').attr('aria-current', 'false');
    $el.attr('aria-current', 'page');
    $('.SideNav-title--text').text($el.text());
  }
  setSelectedPane(key) {
    // Toggle pane
    super.setSelectedPane(key);

    /*
     If the reference designs tab is not selected by default, the masonry grid / slick carousel / RR will
     not instantiate properly due to ( display: none ). The grid will look out of sync
     This is to attach a click handler to the event to resize the window to recalculate

     On top of all of that, if you:
        1) Click on another tab
        2) resize the browser
        3) return to the pane from step 1

      You will now see the carousel / slick slider / RR broken
    */
    mediator.trigger(config.events.masonry.resize, {});

    // Sometimes reference designs needs an extra kick
    // Go to articles and videos, then go back to reference designs or about and the resize event does not trigger the carousel
    this.$el.find('.ResponsiveCarousel').each((_, el) => {
      // No idea why I have to use jQuery instead of $ but they return different results trying to pull the data attribute
      // I believe it is because it's attempting to pull a jquery instance from a data attribute which does not work as I expect
      let $view = jQuery(el).data('view');

      // Try this one and compare it to $view. Sad panda
      // let $view2 = $(el).data('view')
      if ($view) {
        $view.reslick();
      }
    })
  }
  initializeMarketingTracking() {
    let $dataEl = jQuery('.ManufacturerTabs-heroBanner');
    mediator.trigger(config.events.manufacturer.viewPage, {
      manufacturer: $dataEl.data('manufacturer')
    });
  }
  initializeTabs() {
    let visibleTabAttributes = new Set();
    let baseUrl = $(`[${this.sectionTabBaseAttribute}]`).attr('href');

    this.$sections.each((_, el) => {
      if ($(el).attr(this.sectionIdAttribute) === 'datasheets') {
        let dataSheetCount = $('.SearchResults-datasheetRow').length;
        if (dataSheetCount > 0) {
          visibleTabAttributes.add($(el).attr(this.sectionIdAttribute));
        }
      } else {
        visibleTabAttributes.add($(el).attr(this.sectionIdAttribute));
      }
    });

    this.$links.each((_, el) => {
      let $el = $(el);
      let attr = $el.attr(this.sectionKeyAttribute);
      let $link = $(`[${this.sectionKeyAttribute}="${attr}"]`);

      // If tab has corresponding section
      //  then show it visibly and create the missing href
      // else
      //  delete that tab in the DOM for SEO purpose
      if (this.isTabVisible(visibleTabAttributes, attr) && $link.length) {
        if ($el.attr('href') === '#') {
          $el.attr('href', baseUrl + '/' + attr);
        }
        $link.parent().show();
      }
      else {
        $link.parent().remove();
      }
    });

    super.initializeTabs();
  }
  initializePopState() {
    let $baseTab = this.$baseTab;

    window.onpopstate = (event) => {
      if (event.state) {
        let $el = this.$el.find(`[${this.sectionKeyAttribute}="${event.state.key}"]`);
        this.setState($el, true);
      }
      else {
        //Navigate back to first tab
        this.setState($baseTab, true);
      }
    }
  }
  isTabVisible(allVisibleTabNames, tabName) {
    return allVisibleTabNames.has(tabName)
  }
}

export function createManufacturerTabsView($parent) {
  $parent.find('.ManufacturerTabs').each((_, el) => {
    new ManufacturerTabsView({
      el,
      skipFirstPageInHistory: true,
      enableBreadCrumb: true});
  });
}



// WEBPACK FOOTER //
// ./assets/components/ManufacturerTabs/ManufacturerTabsView.js